<template>
  <div class="ivu-shrinkable-menu" v-if="menuList.length > 0">
    <slot name="top"></slot>
    <sidebar-menu
      v-show="!shrink"
      :menu-theme="theme"
      :menu-list="menuList"
      :open-names="openNames"
      @on-change="handleChange"
      :iconSize="14"
    ></sidebar-menu>
  </div>
</template>

<script>
import sidebarMenu from './components/sidebarMenu.vue'
import util from '@/libs/util'
export default {
  name: 'shrinkableMenu',
  components: {
    sidebarMenu,
  },
  props: {
    shrink: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      default: 'dark',
      validator(val) {
        return util.oneOf(val, ['dark', 'light'])
      },
    },
    beforePush: {
      type: Function,
    },
    openNames: {
      type: Array,
    },
  },
  methods: {
    handleChange(name) {
      // 解决重复跳转的问题
      if (this.$route.name === name) {
        return false
      }
      let willpush = true
      if (this.beforePush !== undefined) {
        if (!this.beforePush(name)) {
          willpush = false
        }
      }
      if (willpush) {
        this.$router.push({
          name: name,
        })
      }
      this.$emit('on-change', name)
    },
  },
}
</script>
